import axios from '../api/index.js';

//进行中的证书
export let getQueryEntByBusinessId = (params) => {
    return axios.post(`/client/wm/ent/enroll/queryEntByBusinessId?businessId=${params}`);
};

//已有证书
export let getWmEntCertList = (params) => {
    return axios.post(`/client/wm/ent/enroll/getWmEntCertList?businessId=${params}`);
};

//是否可以申请
export let getEnrollIsCanApply = () => {
    return axios.post(`/client/wm/ent/enroll/isCanApply`);
};

//获取报名证书信息
export let getWMEnrollCertUser = () => {
    return axios.get(`/client/wm/ent/enroll/cert/ent`);
};

//是否可以申请（是否有同类型证书）（修改之后）
export let getEnrollIsCanApplyCert = (params) => {
    return axios.post(`/client/wm/ent/enroll/isCanApplyCert?businessId=${params.businessId}&certType=${params.certType}`);
};

//判断升级条件
export let getEnrollApplyCondition = (params) => {
    return axios.post(`/client/wm/ent/enroll/applyCondition?businessId=${params.businessId}&certDictId=${params.certDictId}&certType=${params.certType}`);
};

//升级证书
export let getEnrollUpgradeCertEnroll = (params) => {
    return axios.post(`/client/wm/ent/enroll/upgradeCertEnroll?businessId=${params.businessId}&entCertDictId=${params.certDictId}`);
};

//申请证书
export let postCreateEntEnroll = (params) => {
    return axios.post(`/client/wm/ent/enroll/createEntEnroll?businessId=${params.businessId}&entCertDictId=${params.certDictId}`);
};

//查寻报名时上传的表格
export let getEnrollEntTable = (params) => {
    return axios.get(`/client/wm/ent/enroll/enrollEntTable/${params}`);
};

//添加表格
export let postEnrollEntTable = (params) => {
    return axios.post(`/client/wm/ent/enroll/saveTable`, params);
};

//获取上传的文件
export let getUploadEntSource = (params) => {
    return axios.get(`/client/wm/ent/enroll/uploadEntSource?id=${params}`);
};

//上传企业材料
export let postUploadEntSource = (params) => {
    return axios.post(`/client/wm/ent/enroll/uploadEntSource`, params);
};

//报名删除
export let deleteEnrollUploadEnt = (params) => {
    return axios.get(`/client/wm/ent/enroll/enroll/remove/${params}`);
};

//获得证书
export let getEnrollCertUser = (params) => {
    return axios.get(`/client/wm/ent/enroll/cert/${params}`);
};

//通过证书id查询证书
export let getQueryEntCertByEnrollId = (params) => {
    return axios.get(`/client/wm_ent_cert/queryEntCertByEnrollId/${params}`);
};

//根据编号查询证书
export let getQueryEntCertById = (params) => {
    return axios.get(`/client/wm_ent_cert/queryEntCertById/${params}`);
};

//删除证书补改证记录
export let handleDeleteUserCert = (params) => {
    return axios.delete(`/client/wm_ent_cert/${params}`);
};

//申请补证
export let putUserCertModify = (params) => {
    return axios.post(`/client/wm_ent_cert/modifyCert`, params);
};

//申请改证
export let putUserCertSave = (params) => {
    return axios.post(`/client/wm_ent_cert/supCert`, params);
};

//获取企业补考证详情
export let getQueryUserCert = (params) => {
    return axios.get(`/client/wm_ent_cert/operation/info/${params.entCertId}/${params.type}`);
};

//获取企业补改证列表
export let getQueryUserCertList = (params) => {
    return axios.get(`/client/wm_ent_cert/operation/list/${params.usersCertId}/${params.serviceType}`);
};

//获取证书(获取支付价格)
export let getQueryCertById = (params) => {
    return axios.get(`/client/wm_ent_cert_dict/${params}`);
};

//提交支付凭证
export let postUserCertImportPay = (params) => {
    return axios.post(`/client/wm_ent_cert/importPay`, params);
};


/////////换证//////////////////
//进行中的证书
export let getQueryEntRenewalsByBusinessId = (params) => {
    return axios.post(`/wm/ent/enroll/renewals/queryEntByUserCertId?userCertId=${params}`);
};

//是否可以申请
export let getEnrollRenewalIsCanApply = () => {
    return axios.post(`/wm/ent/enroll/renewals/isCanApply`);
};

// //判断申请条件
// export let getEnrollRenewalApplyCondition = (params) => {
//     return axios.post(`/wm/ent/enroll/renewals/applyCondition?businessId=${params.businessId}&certDictId=${params.certDictId}&certType=${params.certType}`);
// };

//申请证书
export let postCreateEntEnrollRenewal = (params) => {
    return axios.post(`/wm/ent/enroll/renewals/createEntEnroll?businessId=${params.businessId}&entCertDictId=${params.entCertDictId}&entCertId=${params.entCertId}`);
};

//根据证书编号 获取 证书详情
export let getWmEntCertById = (params) => {
    return axios.get(`/client/wm_ent_cert/getWmEntCertById/${params}`);
};

//删除申请记录
export let detEnrollEntRenewalTable = (params) => {
    return axios.get(`/wm/ent/enroll/renewals/enroll/remove/${params}`);
};


//查寻报名时上传的表格
export let getEnrollEntRenewalTable = (params) => {
    return axios.get(`/wm/ent/enroll/renewals/enrollEntTable/${params}`);
};

//添加表格
export let postEnrollEntRenewalTable = (params) => {
    return axios.post(`/wm/ent/enroll/renewals/saveTable`, params);
};

//获取上传的文件
export let getUploadEntRenewalSource = (params) => {
    return axios.get(`/wm/ent/enroll/renewals/uploadEntSource?id=${params}`);
};

//上传企业材料
export let postUploadEntRenewalSource = (params) => {
    return axios.post(`/wm/ent/enroll/renewals/uploadEntSource`, params);
};

//报名删除
export let deleteEnrollRenewalUploadEnt = (params) => {
    return axios.get(`/wm/ent/enroll/renewals/enroll/remove/${params}`);
};

//上传凭证
export let postEnrollImportPay = (params) => {
    return axios.post(`/client/wm/ent/enroll/importPay`, params);
};

//上传凭证(企业)
export let postEnrollImportPayRenewals = (params) => {
    return axios.post(`/wm/ent/enroll/renewals/importPay`, params);
};

//下载pdf企业--报名信息
//补充信息
export let getDownLoadPdfBusinessInfo = (params) => {
    return axios.get(`/client/wm/ent/enroll/downLoadPdfBusinessInfo/${params}`);
};

//证书匹配
export let getMatchEntCert = (params) => {
    return axios.get(`client/wm_ent_cert/matchUserCert/${params}`);
};

//已有证书 单查补改证状态
export let getQueryWmEntCertSunStatus = (params) => {
    return axios.get(`client/wm_ent_cert/queryWmEntCertSunStatus/${params}`);
};

//已有证书 单查补改证状态
export let getEntCertDictByLevelAndType = (params) => {
    return axios.get(`client/wm_ent_cert_dict/entCertDictByLevelAndType/${params.level}/${params.type}`);
};


//报名撤销
export let postEnrollModifyStatus = (params) => {
    return axios.post(`client/wm/ent/enroll/modifyStatus`, params);
};



// WEBPACK FOOTER //
// ./src/api/wmqy_cert.js